export default __webpack_public_path__ + "static/media/ceramic-coating-1.76bf0214.jpg";